import { TAGS } from "../constants";
import { SmsMessageWithSender } from "../types";
import { api } from "./api";

export const smsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendSms: builder.mutation<
      SmsMessageWithSender,
      { to: string; body: string }
    >({
      query: (body) => ({
        url: `/api/sms`,
        method: "POST",
        body,
      }),
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          smsApi.util.updateQueryData(
            "getTextMessages",
            { patient_profile_id: data.patient_profile_id },
            (draft) => {
              (draft ?? [])[draft.length] = data;
            },
          ),
        );
      },
    }),
    getTextMessages: builder.query<
      SmsMessageWithSender[],
      { patient_profile_id: string }
    >({
      query: (params) => ({
        url: `/api/sms`,
        method: "GET",
        params,
      }),
      providesTags(_result, _error, arg) {
        return [
          { type: TAGS.PATIENT_TEXT_MESSAGES, id: arg.patient_profile_id },
        ];
      },
    }),
    generateSmsSuggestion: builder.query<string, string>({
      query: (patientProfileId) => ({
        method: "GET",
        url: `/api/sms/${patientProfileId}/suggestion`,
        responseHandler: "text",
      }),
    }),
  }),
});

export const {
  useSendSmsMutation,
  useGetTextMessagesQuery,
  useGenerateSmsSuggestionQuery,
} = smsApi;
